import { useCallback, useEffect, useState } from "react";
import { useAppSelector } from "../../hooks/redux";
import store, { RootState } from "../../store/store";
import Button from "../common/Button";
import { gameActions } from "../Game/gameSlice";
import "./User.scss";
import { useNavigate, useParams } from "react-router-dom";
import { LocalStorageKeys } from "../../models/LocalStorageKeys";
import React from "react";
import useGlobalBodyClick from "../../hooks/useGlobalBodyClick";
import UserHeading from "./UserHeading";

const DISCORD_ID_MAX_LENGTH = 22;

export default function NewPlayerForm() {


  const [showHelp, setShowHelp] = React.useState(false);

  const keyPressed = useCallback((event) => {
    switch (event.key) {
      case 'Escape':
        setShowHelp(false);
        break;
      default:
        break;
    }
  }, []);

  useGlobalBodyClick((target: Element) => {
    if (showHelp) {
      setShowHelp(false);
    }
  });

  useEffect(() => {
    document.addEventListener("keydown", keyPressed, false);

    return () => {
      document.removeEventListener("keydown", keyPressed, false);
    };
  }, [keyPressed]);

  const navigate = useNavigate();
  const gameState = useAppSelector((state: RootState) => state.game);

  const { gameId } = useParams();
  const localToken = localStorage.getItem(LocalStorageKeys.TOKEN_KEY);

  useEffect(() => {

    if (localToken && gameState.token) {
      if (gameId) {
        navigate(`/${gameId || ''}`, { replace: true });
        return;
      }
      navigate(`/`, { replace: true });
      return;
    }

  }, [gameId, localToken, navigate]);

  useEffect(() => {
    if (gameState.token) {
      localStorage.setItem(LocalStorageKeys.TOKEN_KEY, gameState.token);
      navigate(`/${gameId || ''}`, { replace: true });
    }
  }, [gameState.token, navigate]);

  const playerName = localStorage.getItem(LocalStorageKeys.NAME_KEY);

  const [formName, setFormName] = useState(playerName || '');
  const [formDiscordId, setFormDiscordId] = useState('');
  const [formIdCheck, setFormIdCheck] = useState(true);
  const [formToken, setFormToken] = useState('');
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [useToken, setUseToken] = useState(false);

  const isSubmitDisabled = hasSubmitted || (useToken ? !formToken : ((!formName && formIdCheck) || (!formIdCheck && !formDiscordId)));

  function handleSubmit(e: any) {
    e.preventDefault();
    if (!gameState.isConnected) {
      return;
    }
    setHasSubmitted(true);

    if (useToken) {
      store.dispatch(gameActions.sendToken({
        token: formToken,
        gameId: gameState.gameId,
      }));
    } else {
      localStorage.setItem(LocalStorageKeys.DISCORD_ID_KEY, formDiscordId);
      localStorage.setItem(LocalStorageKeys.NAME_KEY, formName);

      store.dispatch(gameActions.sendUser({
        discordId: formIdCheck ? "" : formDiscordId.trim(),
        name: formName,
      }));
    }
  }

  function handleTokenChange(e: any) {
    setHasSubmitted(false);
    setFormToken(e.target.value);
  }

  function navigateToMatchmaking() {
    navigate(`/`, { replace: true });
  }

  return (
    <>
      <UserHeading
        onHelp={() => setShowHelp(!showHelp)}
        text={useToken ? 'existing player, enter your token' : `create new player (haven't played here before)`}
        onClose={() => navigateToMatchmaking()}
      />

      {showHelp && <div className="status_info_help game_tooltip right-aligned">
        <div onClick={() => setShowHelp(false)} className="close_button no-select">×</div>
        <div>

          <b>Play on multiple devices</b><br /><br />

          <p>To play the game across multiple devices, you will need your access token:</p>
          <p>On your previously connected device, go to Settings to find your token.</p>
          <p>Enter this token on your new device to sync your account stats and ongoing games.</p>

        </div>
      </div>}

      <div className="player-form">
        <div className="player-form_content">
          <form onSubmit={handleSubmit}>
            <fieldset>
              <label>
                <div>your name:</div>
                <input
                  autoFocus={!useToken}
                  readOnly={false}
                  maxLength={16}
                  disabled={useToken}
                  onChange={e => setFormName(e.target.value)}
                  type="text"
                  name="formName"
                  value={`${formName || ''}`}
                  placeholder=""
                />
              </label>
              {/* not sure if makes sense to keep discord option, it can be confusing for a new player */}

              {/* <label>
                <input type="checkbox"
                  checked={formIdCheck}
                  disabled={useToken}
                  onChange={(e) => setFormIdCheck(e.target.checked)}
                />
                <span>I do not have discord id</span>
              </label> */}

              {!formIdCheck && <label>
                <div>discord Id (numeric):</div>
                <input
                  readOnly={false}
                  maxLength={DISCORD_ID_MAX_LENGTH}
                  disabled={formIdCheck || useToken}
                  onChange={e => setFormDiscordId(e.target.value)}
                  type="text"
                  name="formDiscordId"
                  value={`${formDiscordId || ''}`}
                  placeholder=""
                />
              </label>}

              <label>
                <input type="checkbox"
                  checked={useToken}
                  onChange={(e) => setUseToken(e.target.checked)}
                />
                <span>I have a played before</span>
              </label>

              {useToken && <label>
                <div>your token (from the settings):</div>
                <input
                  autoFocus={useToken}
                  readOnly={false}
                  maxLength={10}
                  onChange={e => handleTokenChange(e)}
                  type="text"
                  name="formToken"
                  value={`${formToken || ''}`}
                  placeholder=""
                />
              </label>}

              <Button onClick={handleSubmit} text="Submit" disabled={isSubmitDisabled} />
            </fieldset>
          </form>
        </div>
      </div>
    </>
  )
}